import {PaymentCodeEnum} from "capitalist-shared/src/finance/payments";
import DropdownLogoSbp from "@/components/forms/payout/payways/DropdownLogoSbp.vue";
import DropdownLogoBitcoin from "@/components/forms/payout/payways/DropdownLogoBitcoin.vue";
import DropdownLogoCapitalist from "@/components/forms/payout/payways/DropdownLogoCapitalist.vue";
import {CurrencyCode} from "@/models/core/currency";
import DropdownLogoCapitalistVoucher
  from "@/components/forms/payout/payways/DropdownLogoCapitalistVoucher.vue";
import DropdownLogoCapitalistMasspayments
  from "@/components/forms/payout/payways/DropdownLogoCapitalistMasspayments.vue";
import DropdownLogoCapitalistCardTopup
  from "@/components/forms/payout/payways/DropdownLogoCapitalistCardTopup.vue";
import DropdownLogoWebmoney from "@/components/forms/payout/payways/DropdownLogoWebmoney.vue";
import DropdownLogoYoomoneyShort
  from "@/components/forms/payout/payways/DropdownLogoYoomoneyShort.vue";
import DropdownLogoQiwiShort from "@/components/forms/payout/payways/DropdownLogoQiwiShort.vue";
import DropdownLogoShadowCards from "@/components/forms/payout/payways/DropdownLogoShadowCards.vue";
import DropdownLogoMobile from "@/components/forms/payout/payways/DropdownLogoMobile.vue";
import DropdownLogoEthereumShort
  from "@/components/forms/payout/payways/DropdownLogoEthereumShort.vue";
import DropdownLogoUsdt from "@/components/forms/payout/payways/DropdownLogoUsdt.vue";
import DropdownLogoUsdc from "@/components/forms/payout/payways/DropdownLogoUsdc.vue";
import DropdownLogoMts from "@/components/forms/payout/payways/DropdownLogoMts.vue";
import DropdownLogoBeeline from "@/components/forms/payout/payways/DropdownLogoBeeline.vue";
import DropdownLogoMegafon from "@/components/forms/payout/payways/DropdownLogoMegafon.vue";
import DropdownLogoYota from "@/components/forms/payout/payways/DropdownLogoYota.vue";
import DropdownLogoTele2 from "@/components/forms/payout/payways/DropdownLogoTele2.vue";
import DropdownLogoPaytm from "@/components/forms/payout/payways/DropdownLogoPaytm.vue";
import DropdownLogoNeteller from "@/components/forms/payout/payways/DropdownLogoNeteller.vue";
import DropdownLogoSkrill from "@/components/forms/payout/payways/DropdownLogoSkrill.vue";
import DropdownLogoImps from "@/components/forms/payout/payways/DropdownLogoImps.vue";
import DropdownLogoBank from "@/components/forms/payout/payways/DropdownLogoBank.vue";
// import DropdownLogoSbpDark from "@/components/forms/payout/payways/DropdownLogoSbpDark.vue";
import DropdownLogoPix from "@/components/forms/payout/payways/DropdownLogoPix.vue";
import DropdownLogoPse from "@/components/forms/payout/payways/DropdownLogoPse.vue";
import DropdownLogoSpei from "@/components/forms/payout/payways/DropdownLogoSpei.vue";
import DropdownLogoTmobile from "@/components/forms/payout/payways/DropdownLogoTmobile.vue";
import DropdownLogoPayoneer from "@/components/forms/payout/payways/DropdownLogoPayoneer.vue";
import DropdownLogoPapara from "@/components/forms/payout/payways/DropdownLogoPapara.vue";
import DropdownLogoAfrica from "@/components/forms/payout/payways/DropdownLogoAfrica.vue";
import DropdownLogoBkash from "@/components/forms/payout/payways/DropdownLogoBkash.vue";
import DropdownLogoGCash from "@/components/forms/payout/payways/DropdownLogoGCash.vue";
import DropdownLogoZalopay from "@/components/forms/payout/payways/DropdownLogoZalopay.vue";
import DropdownVitaChileLogoBank
  from "@/components/forms/payout/payways/DropdownVitaChileLogoBank.vue";
import DropdownLogoTransfiya from "@/components/forms/payout/payways/DropdownLogoTransfiya.vue";
import DropdownLogoTpaga from "@/components/forms/payout/payways/colombia/DropdownLogoTpaga.vue";
import DropdownLogoNequi from "@/components/forms/payout/payways/colombia/DropdownLogoNequi.vue";
// import DropdownLogoGhana from "@/components/forms/payout/payways/DropdownLogoGhana.vue";


export type PaywayConfig = {
  id?: string;
  system: PaymentCodeEnum;
  title: string;
  icon?: string | Vue.Component;
  currency?: CurrencyCode[] | CurrencyCode | string[] | string;
  country?: string;
  height?: number;
  query?: Record<string, string>;
}

const cardsSize = 21;
export const config: PaywayConfig[] = [
  {
    system: PaymentCodeEnum.Wire,
    title: 'Wire',
    icon: DropdownLogoBank,
    height: 32
  },
  {
    system: PaymentCodeEnum.SEPA_EUR,
    title: 'SEPA',
    icon: DropdownLogoBank,
    height: 32
  },
  {
    system: PaymentCodeEnum.Bitcoin,
    title: 'Bitcoin',
    icon: DropdownLogoBitcoin,
    height: 32
  },
  {
    system: PaymentCodeEnum.Capitalist,
    title: 'Внутренний счет Capitalist',
    icon: DropdownLogoCapitalist,
    height: 30
  },
  {
    system: PaymentCodeEnum.CardsTopUp,
    title: 'Пополнение карты Capitalist',
    icon: DropdownLogoCapitalistCardTopup,
    height: 30
  },
  {
    system: PaymentCodeEnum.Webmoney,
    title: 'Webmoney',
    icon: DropdownLogoWebmoney,
    height: 30
  },
  {
    system: PaymentCodeEnum.YandexMoney,
    title: 'ЮMoney',
    icon: DropdownLogoYoomoneyShort,
    height: 25
  },
  {
    system: PaymentCodeEnum.Payoneer,
    title: 'Payoneer',
    icon: DropdownLogoPayoneer,
    height: 25
  },
  {
    system: PaymentCodeEnum.Papara,
    title: 'Papara',
    icon: DropdownLogoPapara,
    height: 20,
    country: 'TR'
  },
  {
    system: PaymentCodeEnum.BangladeshBkash,
    title: 'bKash',
    country: 'BD',
    icon: DropdownLogoBkash,
    height: 32
  },
  {
    system: PaymentCodeEnum.GCash,
    title: 'GCash',
    country: 'PH',
    icon: DropdownLogoGCash,
    height: 32
  },
  {
    system: PaymentCodeEnum.ZaloPay,
    title: 'ZaloPay',
    country: 'VN',
    icon: DropdownLogoZalopay,
    height: 32
  },
  {
    system: PaymentCodeEnum.Qiwi,
    title: 'Qiwi',
    icon: DropdownLogoQiwiShort,
    height: 30
  },
  {
    system: PaymentCodeEnum.TurkeyCards,
    title: 'Банковские карты Турции',
    currency: [CurrencyCode.TRY],
    icon: DropdownLogoShadowCards,
    country: 'TR',
    height: cardsSize
  },
  {
    system: PaymentCodeEnum.GeorgiaCards,
    title: 'Банковские карты Грузии',
    icon: DropdownLogoShadowCards,
    currency: [CurrencyCode.GEL],
    country: 'GE',
    height: cardsSize
  },
  {
    system: PaymentCodeEnum.ArgentinaBanks,
    title: 'Банковские счета Аргентины',
    icon: DropdownLogoBank,
    currency: [CurrencyCode.ARS],
    country: 'AR',
    height: cardsSize
  },
  {
    system: PaymentCodeEnum.BrazilPix,
    title: 'Бразильский PIX',
    icon: DropdownLogoPix,
    currency: [CurrencyCode.BRL],
    country: 'BR',
    height: cardsSize
  },
  {
    system: PaymentCodeEnum.ColombiaBanks,
    title: 'Колумбийский PSE',
    icon: DropdownLogoPse,
    currency: [CurrencyCode.COP],
    country: 'CO',
    height: cardsSize
  },
  {
    system: PaymentCodeEnum.MexicoBanks,
    title: 'Мексиканский SPEI',
    icon: DropdownLogoSpei,
    currency: [CurrencyCode.MXN],
    country: 'MX',
    height: cardsSize
  },

  {
    system: PaymentCodeEnum.PAGS_BRBANK,
    title: 'Банковский счет в Бразилии',
    icon: DropdownLogoBank,
    currency: [CurrencyCode.BRL],
    country: 'BR',
    height: cardsSize
  },

  {
    system: PaymentCodeEnum.PAGS_PERU_BANK,
    title: 'Банковский счет в Перу',
    icon: DropdownLogoBank,
    currency: [CurrencyCode.PEN],
    country: 'PE',
    height: cardsSize
  },

  {
    system: PaymentCodeEnum.PAGS_ECUADOR_BANK,
    title: 'Банковский счет в Эквадоре',
    icon: DropdownLogoBank,
    currency: [CurrencyCode.ECS],
    country: 'EC',
    height: cardsSize
  },

  {
    system: PaymentCodeEnum.PAGS_BOLIVIAN_BANK,
    title: 'Банковский счет в Боливии',
    icon: DropdownLogoBank,
    currency: [CurrencyCode.BOB],
    country: 'BO',
    height: cardsSize
  },

  {
    system: PaymentCodeEnum.PAGS_COSTA_RICA_BANK,
    title: 'Банковский счет в Коста-Рике',
    icon: DropdownLogoBank,
    currency: [CurrencyCode.CRC],
    country: 'CR',
    height: cardsSize
  },

  // {
  //   system: PaymentCodeEnum.PAGS_BRPIX,
  //   title: 'Бразильский PIX',
  //   icon: DropdownLogoPix,
  //   currency: [CurrencyCode.BRL],
  //   country: 'BR',
  //   height: cardsSize
  // },

  {
    system: PaymentCodeEnum.PAGS_COLOMBIA_WALLET,
    title: 'Колумбийский Wallet',
    icon: DropdownLogoBank,
    currency: [CurrencyCode.COP],
    country: 'CO',
    height: cardsSize
  },

  {
    system: PaymentCodeEnum.PAGS_COWALLET_NEQUI,
    title: 'Колумбийский Nequi',
    icon: DropdownLogoNequi,
    currency: [CurrencyCode.COP],
    country: 'CO',
    height: 28
  },

  {
    system: PaymentCodeEnum.PAGS_COWALLET_TPAGA,
    title: 'Колумбийский Tpaga',
    icon: DropdownLogoTpaga,
    currency: [CurrencyCode.COP],
    country: 'CO',
    height: cardsSize
  },

  {
    system: PaymentCodeEnum.PAGS_COLOMBIA_BANK,
    title: 'Банковский счет в Колумбии',
    icon: DropdownLogoBank,
    currency: [CurrencyCode.COP],
    country: 'CO',
    height: cardsSize
  },

  {
    system: PaymentCodeEnum.PAGS_COLOMBIA_TRANSFIYA,
    title: 'Колумбийский Transfiya',
    icon: DropdownLogoTransfiya,
    currency: [CurrencyCode.COP],
    country: 'CO',
    height: cardsSize
  },

  {
    system: PaymentCodeEnum.PAGS_CHILE_WALLET,
    title: 'Чилийский Vita Wallet',
    icon: DropdownVitaChileLogoBank,
    currency: [CurrencyCode.CLP],
    country: 'CL',
    height: cardsSize
  },

  {
    system: PaymentCodeEnum.PAGS_MXSPEI,
    title: 'Мексиканский SPEI',
    icon: DropdownLogoSpei,
    currency: [CurrencyCode.MXN],
    country: 'MX',
    height: cardsSize
  },

  {
    system: PaymentCodeEnum.INDIA_BANKS,
    title: 'Банковский счет в Индии',
    icon: DropdownLogoBank,
    currency: [CurrencyCode.INR],
    country: 'IN',
    height: cardsSize
  },
  {
    system: PaymentCodeEnum.MALAYSIA_BANKS,
    title: 'Банковский счет в Малайзии',
    icon: DropdownLogoBank,
    currency: [CurrencyCode.MYR],
    country: 'MY',
    height: cardsSize
  },
  {
    system: PaymentCodeEnum.THAILAND_BANKS,
    title: 'Банковский счет в Тайланде',
    icon: DropdownLogoBank,
    currency: [CurrencyCode.THB],
    country: 'TH',
    height: cardsSize
  },
  {
    system: PaymentCodeEnum.SOUTH_KOREA_BANKS,
    title: 'Банковский счет в Южной Корее',
    icon: DropdownLogoBank,
    currency: [CurrencyCode.KRW],
    country: 'KR',
    height: cardsSize
  },

  {
    system: PaymentCodeEnum.INDONESIA_BANKS_SP,
    title: 'Банковский счет в Индонезии',
    icon: DropdownLogoBank,
    currency: [CurrencyCode.IDR],
    country: 'ID',
    height: cardsSize
  },

  {
    system: PaymentCodeEnum.IMPS_SP_INDIA_BANKS,
    title: 'Банковский счет в Индии',
    icon: DropdownLogoBank,
    currency: [CurrencyCode.INR],
    country: 'IN',
    height: cardsSize
  },

  {
    system: PaymentCodeEnum.INDONESIA_BANKS,
    title: 'Банковский счет в Индонезии',
    icon: DropdownLogoBank,
    currency: [CurrencyCode.IDR],
    country: 'ID',
    height: cardsSize
  },

  {
    system: PaymentCodeEnum.PAGS_CHILE_BANK,
    title: 'Банковский счет в Чили',
    icon: DropdownLogoBank,
    currency: [CurrencyCode.CLP],
    country: 'CL',
    height: cardsSize
  },

  // {
  //   system: PaymentCodeEnum.AfricaBanks,
  //   title: 'Банковские счета Африки',
  //   icon: DropdownLogoAfrica,
  //   height: 32,
  //   country: 'BANK'
  // },
  {
    system: PaymentCodeEnum.AFRICA_BANKS_GHANA,
    // id: 'africa_bank_ghana',
    title: 'Банковские счета Ганы',
    icon: DropdownLogoBank,
    height: 32,
    country: 'GH',
    query: {
      africaservice: 'ghana_bank'
    }
  },
  {
    system: PaymentCodeEnum.AFRICA_BANKS_NIGERIA,
    // id: 'africa_bank_nigeria',
    title: 'Банковские счета Нигерии',
    icon: DropdownLogoBank,
    height: 32,
    country: 'NG',
    query: {
      africaservice: 'nigeria_bank'
    }
  },
  // {
  //   system: PaymentCodeEnum.AfricaMobile,
  //   title: 'Мобильные операторы Африки',
  //   icon: DropdownLogoAfrica,
  //   country: 'MOBILE',
  //   height: 32
  // },
  // {
  //   system: PaymentCodeEnum.AfricaMobile,
  //   id: 'africa_momo_benin',
  //   title: 'Мобильные операторы Бенина',
  //   icon: DropdownLogoMobile,
  //   height: 32,
  //   country: 'BJ',
  //   query: {
  //     africaservice: 'benin_momo'
  //   }
  // },

  {
    system: PaymentCodeEnum.AFRICA_MOMO_KENYA,
    // id: 'africa_momo_kenya',
    title: 'Мобильные операторы Кении',
    icon: DropdownLogoMobile,
    height: 32,
    country: 'KE',
    query: {
      africaservice: 'kenya_momo'
    }
  },

  {
    system: PaymentCodeEnum.AFRICA_MOMO_GHANA,
    // id: 'africa_momo_ghana',
    title: 'Мобильные операторы Ганы',
    icon: DropdownLogoMobile,
    height: 32,
    country: 'GH',
    query: {
      africaservice: 'ghana_momo'
    }
  },

  // {
  //   system: PaymentCodeEnum.AfricaMobile,
  //   id: 'africa_momo_bf',
  //   title: 'Мобильные операторы Буркина-Фасо',
  //   icon: DropdownLogoMobile,
  //   height: 32,
  //   country: 'BF',
  //   query: {
  //     africaservice: 'bf_momo'
  //   }
  // },
  // {
  //   system: PaymentCodeEnum.AfricaMobile,
  //   id: 'africa_momo_mali',
  //   title: 'Мобильные операторы Мали',
  //   icon: DropdownLogoMobile,
  //   height: 32,
  //   country: 'ML',
  //   query: {
  //     africaservice: 'mali_momo'
  //   }
  // },
  // {
  //   system: PaymentCodeEnum.AfricaMobile,
  //   id: 'africa_momo_senegal',
  //   title: 'Мобильные операторы Сенегала',
  //   icon: DropdownLogoMobile,
  //   height: 32,
  //   country: 'SN',
  //   query: {
  //     africaservice: 'senegal_momo'
  //   }
  // },
  // {
  //   system: PaymentCodeEnum.AfricaMobile,
  //   id: 'africa_momo_togo',
  //   title: 'Мобильные операторы Того',
  //   icon: DropdownLogoMobile,
  //   height: 32,
  //   country: 'TG',
  //   query: {
  //     africaservice: 'togo_momo'
  //   }
  // },
  {
    system: PaymentCodeEnum.AFRICA_MOMO_CAMEROON,
    // id: 'africa_momo_cameroon',
    title: 'Мобильные операторы Камеруна',
    icon: DropdownLogoMobile,
    height: 32,
    country: 'CM',
    query: {
      africaservice: 'cameroon_momo'
    }
  },
  {
    system: PaymentCodeEnum.AFRICA_MOMO_UGANDA,
    // id: 'africa_momo_uganda',
    title: 'Мобильные операторы Уганды',
    icon: DropdownLogoMobile,
    height: 32,
    country: 'UG',
    query: {
      africaservice: 'uganda_momo'
    }
  },
  {
    system: PaymentCodeEnum.AFRICA_MOMO_TANZANIA,
    // id: 'africa_momo_tanzania',
    title: 'Мобильные операторы Танзании',
    icon: DropdownLogoMobile,
    height: 32,
    country: 'TZ',
    query: {
      africaservice: 'tanzania_momo'
    }
  },

  {
    system: PaymentCodeEnum.RussianCards,
    title: 'Банковские карты РФ',
    icon: DropdownLogoShadowCards,
    currency: [CurrencyCode.RUR],
    country: 'RU',
    height: cardsSize
  },

  {
    system: PaymentCodeEnum.Sbp,
    title: 'Банковские карты РФ через СБП',
    icon: DropdownLogoSbp,
    currency: [CurrencyCode.RUR],
    country: 'RU',
    height: 30
  },
  {
    system: PaymentCodeEnum.SngCards,
    title: 'Банковские карты СНГ',
    icon: DropdownLogoShadowCards,
    currency: ['KZT с конвертацией'],
    country: 'CIS',
    height: cardsSize
  },
  {
    system: PaymentCodeEnum.UkrainianCards,
    title: 'Банковские карты Украины',
    icon: DropdownLogoShadowCards,
    currency: [CurrencyCode.UAH],
    country: 'UA',
    height: cardsSize
  },
  {
    system: PaymentCodeEnum.UzbekistanCards,
    title: 'Банковские карты Узбекистана (HUMO/UZCARD)',
    icon: DropdownLogoShadowCards,
    currency: [CurrencyCode.UZS],
    country: 'UZ',
    height: cardsSize
  },
  {
    system: PaymentCodeEnum.AzerbaijanCards,
    title: 'Банковские карты Азербайджана',
    icon: DropdownLogoShadowCards,
    currency: [CurrencyCode.AZN],
    country: 'AZ',
    height: cardsSize
  },

  {
    system: PaymentCodeEnum.KazakhstanCards,
    title: 'Банковские карты Казахстана',
    icon: DropdownLogoShadowCards,
    currency: [CurrencyCode.KZT],
    country: 'KZ',
    height: cardsSize
  },
  {
    system: PaymentCodeEnum.PayTM,
    title: 'PayTM',
    icon: DropdownLogoPaytm,
    currency: [CurrencyCode.INR],
    country: 'IN',
    height:10
  },
  {
    system: PaymentCodeEnum.Neteller,
    title: 'Neteller',
    icon: DropdownLogoNeteller,
    currency: [CurrencyCode.EUR],
    country: 'WORLDWIDE',
    height: 25
  },
  {
    system: PaymentCodeEnum.Skrill,
    title: 'Skrill',
    icon: DropdownLogoSkrill,
    currency: [CurrencyCode.EUR],
    country: 'WORLDWIDE',
    height: 25
  },
  {
    system: PaymentCodeEnum.IMPS,
    title: 'IMPS',
    icon: DropdownLogoImps,
    currency: [CurrencyCode.INR],
    country: 'IN',
    height: 8
  },
  {
    system: PaymentCodeEnum.UkrainianMobile,
    title: 'Мобильные операторы Украины',
    icon: DropdownLogoMobile,
    currency: [CurrencyCode.UAH],
    country: 'UA',
    height: 25
  },
  {
    system: PaymentCodeEnum.Ethereum,
    title: 'Ethereum',
    icon: DropdownLogoEthereumShort,
    height: 34
  },
  {
    system: PaymentCodeEnum.USDC,
    title: 'USDC (Erc-20)',
    icon: DropdownLogoUsdc,
    height: 32
  },
  {
    system: PaymentCodeEnum.Mts,
    title: 'МТС',
    icon: DropdownLogoMts,
    height: 29
  },
  {
    system: PaymentCodeEnum.Tele2,
    title: 'Теле2',
    icon: DropdownLogoTele2,
    height: 14
  },
  {
    system: PaymentCodeEnum.Beeline,
    title: 'Билайн',
    icon: DropdownLogoBeeline,
    height: 29
  },
  {
    system: PaymentCodeEnum.Megafon,
    title: 'Мегафон',
    icon: DropdownLogoMegafon,
    height: 29
  },
  {
    system: PaymentCodeEnum.TinkoffMobile,
    title: 'Т-Мобайл',
    icon: DropdownLogoTmobile,
    height: 29
  },
  {
    system: PaymentCodeEnum.Yota,
    title: 'Yota',
    icon: DropdownLogoYota,
    height: 30
  },
  {
    system: PaymentCodeEnum.USDT,
    title: 'USDT (ERC-20, TRC-20)',
    icon: DropdownLogoUsdt,
    height: 30
  },
  {
    system: PaymentCodeEnum.Cards,
    title: 'Банковские карты Mastercard Worldwide',
    icon: DropdownLogoShadowCards,
    currency: [CurrencyCode.USD, CurrencyCode.EUR],
    country: 'PLANET_EARTH',
    height: cardsSize
  },
  {
    system: PaymentCodeEnum.WorldCardsUsd,
    title: 'Банковские карты Mastercard Worldwide',
    icon: DropdownLogoShadowCards,
    currency: [CurrencyCode.USD],
    country: 'PLANET_EARTH',
    height: cardsSize
  },
  {
    system: PaymentCodeEnum.WorldCardsEuro,
    title: 'Банковские карты Mastercard Worldwide',
    icon: DropdownLogoShadowCards,
    currency: [CurrencyCode.EUR],
    country: 'PLANET_EARTH',
    height: cardsSize
  },
  {
    system: PaymentCodeEnum.CapitalistCheque,
    title: 'Чеки Capitalist',
    icon: DropdownLogoCapitalistVoucher,
    height: 30
  },

  {
    system: PaymentCodeEnum.Masspayments,
    title: 'Массовые платежи',
    icon: DropdownLogoCapitalistMasspayments,
    height: 25
  },
  {
    system: PaymentCodeEnum.Card2Card,
    title: 'Банковские карты РФ (card2card)',
    icon: DropdownLogoShadowCards,
    height: cardsSize,
    country: 'RU',
    currency: [CurrencyCode.RUR],
  }
];
export default config;
